<template>
  <v-alert type="error" :value="showAlert">{{alertText}}</v-alert>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      showAlert: state => state.CommonStore.showAlert,
      alertText: state => state.CommonStore.alertText
    })
  }
};
</script>